import React from "react";

const Home = () => {
    return (
      <div>
        <h1>Welcome to Singh Engineering Solutions Ltd</h1>

        <h3>
          Leaders in Offshore Decommissioning, Subsea Engineering & Oil and Gas
          Consultancy
        </h3>

        <p>
          At Singh Engineering Solutions Ltd (SESLtd), we deliver world-class
          engineering, decommissioning, and offshore consultancy services to the
          oil, gas, and renewable energy industries. Our team has over 19 years
          of experience across the UK Continental Shelf (UKCS), East Irish Sea,
          and international offshore projects, bringing technical excellence,
          precision, and a strong safety culture to every project. From complex
          subsea construction and heavy-lift operations to full EPRD
          (Engineering, Preparation, Removal, and Disposal) campaigns, we
          combine strategic insight with hands-on expertise to ensure every
          project is delivered safely, efficiently, and sustainably.
        </p>
      </div>
    );
}

export default Home;